import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Process } from "@/components/landing/Process";
import { GermanySection } from "@/components/landing/GermanyMap";
import { WebinarContent } from "@/components/landing/WebinarContent";
import { TargetAudience } from "@/components/landing/TargetAudience";
import { Earnings } from "@/components/landing/Earnings";
import { Requirements } from "@/components/landing/Requirements";
import { WebinarSteps } from "@/components/landing/WebinarSteps";
import { Testimonials } from "@/components/landing/Testimonials";
import { Faq } from "@/components/landing/Faq";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { Footer } from "@/components/landing/Footer";
import { StickyMobileCTA } from "@/components/landing/StickyMobileCTA";

export default function LandingPage() {
  return (
    <div className="grain relative min-h-screen bg-brand-bg font-body text-white">
      <Navbar />
      <main>
        <Hero />
        <Process />
        <GermanySection />
        <WebinarContent />
        <TargetAudience />
        <Earnings />
        <Requirements />
        <WebinarSteps />
        <Testimonials />
        <Faq />
        <FinalCTA />
      </main>
      <Footer />
      <StickyMobileCTA />
    </div>
  );
}
